import { render, staticRenderFns } from "./step4-mobile.vue?vue&type=template&id=10ef5938&scoped=true&"
import script from "./step4-mobile.vue?vue&type=script&lang=js&"
export * from "./step4-mobile.vue?vue&type=script&lang=js&"
import style0 from "./step4-mobile.vue?vue&type=style&index=0&id=10ef5938&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ef5938",
  null
  
)

export default component.exports